import React from 'react';
import classnames from 'classnames';

import './CustomInputs.scss';

const CustomTextField = (props) => {
  const {
    header,
    name,
    value,
    onChange,
    error,
  } = props;

  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <div className="CustomInput">
      <div className="CustomInput__Header">{header}</div>
      <input
        className={classnames("CustomInput__TextField InputClass", error ? 'Error' : '')}
        name={name}
        value={value}
        onChange={handleChange}
        type="text"
      />
    </div>
  );
};

export default CustomTextField;
